import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
class IDMeans extends Component {
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            id_type: this.refs.id_type.value,
            number: this.refs.number.value,
            issue_date: this.refs.issue_date.value,
            expiry_date: this.refs.expiry_date.value,
            etcc: this.refs.etcc.value
        }

        this.props.saveValues(data, 'id_means')
        this.props.nextStep()
    }
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Means of Identification (Account Holder 1)</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>ID Type<span className="text-danger">*</span></label>
                                            <select ref="id_type" required className="form-control" defaultValue={this.props.fieldValues.id_type}>
                                                <option value="" hidden>Select...</option>
                                                <option value="International Passport">International Passport</option>
                                                <option value="Driver's Licence">Driver's Licence</option>
                                                <option value="National ID Card">National ID Card</option>
                                                <option value="Permanent Voters Card">Permanent Voters Card</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>ID Number<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="number" placeholder="ID Number" defaultValue={this.props.fieldValues.number} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Issue Date</label>
                                            <Form.Control type="date" className="form-control" ref="issue_date" placeholder="Issue Date" defaultValue={this.props.fieldValues.issue_date} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Expiry Date</label>
                                            <Form.Control type="date" className="form-control" ref="expiry_date" placeholder="Expiry Date" defaultValue={this.props.fieldValues.expiry_date} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>eTCC (Electronic Tax Clearance Certificate</label>
                                            <Form.Control type="text" className="form-control" ref="etcc" placeholder="eTCC (Electronic Tax Clearance Certificate" defaultValue={this.props.fieldValues.etcc} />
                                        </Form.Group>
                                    </div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default IDMeans;